export function loadStoreCityList() {
  return {
    type: 'LOAD_STORE_CITY_LIST',
  };
}

export function loadStoreCityListCompletion(data, error) {
  return {
    type: 'LOAD_STORE_CITY_LIST_COMPLETION',
    data,
    error,
  };
}
export function loadShopList(input) {
  return {
    type: 'LOAD_SHOP_LIST',
    input,
  };
}

export function loadShopListCompletion(data, error) {
  return {
    type: 'LOAD_SHOP_LIST_COMPLETION',
    data,
    error,
  };
}

export function setCity(data) {
  return { type: 'SET_CITY', data };
}

export function setCurrentShop(data) {
  return { type: 'SET_SHOP', data };
}

export function updateAppointInfo(input, reset) {
  return { type: 'UPDATE_APPOINT_INPUT', input, reset };
}

export function loadAppoint(id) {
  return {
    type: 'LOAD_APPOINT',
    id,
  };
}

export function loadAppointCompletion(reserveCode, data, error) {
  return {
    type: 'LOAD_APPOINT_COMPLETION',
    reserveCode,
    data,
    error,
  };
}

export function loadAppointList(query) {
  return {
    type: 'LOAD_APPOINT_LIST',
    query,
    willReload: !!query,
  };
}

export function loadAppointListCompletion(error, list) {
  return {
    type: 'LOAD_APPOINT_LIST_COMPLETION',
    error,
    list,
  };
}

export function cancelAppoint(id) {
  return {
    type: 'CANCEL_APPOINT',
    id,
  };
}

export function cancelAppointCompletion(id, data, error) {
  return {
    type: 'CANCEL_APPOINT_COMPLETION',
    id,
    data,
    error,
  };
}

export function updateAppointLocation(data, reset) {
  return { type: 'UPDATE_APPOINT_LOCATION', data, reset };
}

export function createAppoint() {
  return {
    type: 'CREATE_APPOINT',
  };
}

export function createAppointCompletion(error, data) {
  return {
    type: 'CREATE_APPOINT_COMPLETION',
    error,
    data,
  };
}

export function loadAppointTimes(query) {
  return {
    type: 'LOAD_APPOINT_TIMES_LIST',
    query,
  };
}

export function loadAppointTimesCompletion(data, error) {
  return {
    type: 'LOAD_APPOINT_TIMES_LIST_COMPLETION',
    data,
    error,
  };
}
export function loadCouponListByChannelCode(code) {
  return {
    type: 'LOAD_COUPON_LIST_BY_CHANNEL_CODE',
    channelCode: code,
  };
}

export function loadCouponListByChannelCodeCompletion(error, list) {
  return {
    type: 'LOAD_COUPON_LIST_BY_CHANNEL_CODE_COMPLETION',
    error,
    list,
  };
}
